import { render, staticRenderFns } from "./step1_description.vue?vue&type=template&id=247fce37&scoped=true&"
import script from "./step1_description.vue?vue&type=script&lang=js&"
export * from "./step1_description.vue?vue&type=script&lang=js&"
import style0 from "./step1_description.vue?vue&type=style&index=0&id=247fce37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fce37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247fce37')) {
      api.createRecord('247fce37', component.options)
    } else {
      api.reload('247fce37', component.options)
    }
    module.hot.accept("./step1_description.vue?vue&type=template&id=247fce37&scoped=true&", function () {
      api.rerender('247fce37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Report/step1_description.vue"
export default component.exports